module.exports = __webpack_public_path__ + "static/media/Surfer Girl.34dfe706.jpg";